// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Estils específics de Detallsempleat.js. S'afegeixen aquí (i no a
   dashboard.css) perquè només afecten aquesta pantalla i és fàcil de
   revertir si cal. */

/* Resum en text pla de l'Horari (mode Consultar/Esborrar) */
.horari-resum-llista {
  display: inline-block;
  vertical-align: top;
}

.horari-resum-periode {
  margin-bottom: 0.4rem;
}

.horari-resum-periode:last-child {
  margin-bottom: 0;
}

.horari-resum-grup {
  padding-left: 1.2rem;
}
`, "",{"version":3,"sources":["webpack://./src/pages/dashboard/detallsempleat.css"],"names":[],"mappings":"AAAA;;qBAEqB;;AAErB,4DAA4D;AAC5D;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;AACtB","sourcesContent":["/* Estils específics de Detallsempleat.js. S'afegeixen aquí (i no a\r\n   dashboard.css) perquè només afecten aquesta pantalla i és fàcil de\r\n   revertir si cal. */\r\n\r\n/* Resum en text pla de l'Horari (mode Consultar/Esborrar) */\r\n.horari-resum-llista {\r\n  display: inline-block;\r\n  vertical-align: top;\r\n}\r\n\r\n.horari-resum-periode {\r\n  margin-bottom: 0.4rem;\r\n}\r\n\r\n.horari-resum-periode:last-child {\r\n  margin-bottom: 0;\r\n}\r\n\r\n.horari-resum-grup {\r\n  padding-left: 1.2rem;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
